import React from 'react';

import ExploitationIcon from 'components/icons/Exploitation';
import { ArableContext, ExploitationContext } from 'utils/context';
import { useContext } from 'react';
import { filterParcelFromActivityDate } from 'utils/Datagrid/CustomParcelstDataGridUtils';
import { useTranslation } from 'react-i18next';

const ExploitationHeader = () => {
  const { arableSurface } = useContext(ArableContext);
  const { exploitationContext } = useContext(ExploitationContext);
  const { t } = useTranslation();

  return (
    <div>
      {exploitationContext && (
        <span className="title_spacing">
          <span className="subtitle_spacing">
            <ExploitationIcon width={30.0} height={30} fill="$secondary" />
          </span>
          <span className="green_text subtitle_spacing">{exploitationContext?.name}</span>
          <span className="subtitle_spacing">
            {exploitationContext?.code ? ' - ' + exploitationContext?.code : ''}
          </span>
          <span className="subtitle_spacing">
            {arableSurface ? (
              <div>
                {' '}
                - {t('label.surfaceArable')}: <b>{arableSurface.toFixed(2)} ha</b>
              </div>
            ) : (
              ''
            )}
          </span>
          <span className="subtitle_spacing">
            <div>
              {' '}
              - {t('label.SAU')}:{' '}
              <b>
                {filterParcelFromActivityDate(
                  exploitationContext?.parcels,
                  exploitationContext?.forecastCampaign
                )
                  .reduce((sum, currentValue) => sum + currentValue.surface, 0)
                  .toFixed(2)}{' '}
                ha
              </b>
            </div>
          </span>
        </span>
      )}
    </div>
  );
};

export default ExploitationHeader;
